<template>
  <div id="app">
    <v-app>

      <ToolBar />

      <v-main>
        <v-container fill-height>
          <v-scroll-x-transition mode="out-in">
            <router-view/>
          </v-scroll-x-transition>
        </v-container>
      </v-main>

      <FooterBar />

    </v-app>
  </div>
</template>

<style lang="scss">
#app {
  background: no-repeat center/cover url("../public/background2.jpg");
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>

<script>
import ToolBar from '@/components/ToolBar.vue'
import FooterBar from '@/components/FooterBar.vue';

export default {
  components: {
    ToolBar,
    FooterBar
  }
}

</script>